<app-header></app-header>
<main class="pages">
    <!--PAGE Hero Section -->
    <section class="gradient-light">
        <div class="container pt-lg-5">
            <div class="row align-items-center">
                <div class="col-md-6">
                    <h1 class="page-hero-title mt-3">Terms of Service</h1>
                    <p class="sub-text mt-3">Lorem Ipsum is simply dummy text of the printing and typesetting industry. </p>
                    <div class="mt-5">
                        <button class="btn btn-success btn-lg px-5 text-uppercase" type="button" data-toggle="modal" data-target="#callBack" id="callback">REQUEST A DEMO</button>
                    </div>
                </div>
                <div class="col-md-6 ">
                    <div class="page-banner-img">
                        <img class="img-fluid" alt="Retails and Manufacturing" title="" src="assets/employee-experience.svg">
                    </div>
                </div>
            </div>
        </div>
    </section>



    <section class="py-lg-5">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <h1 class="page-hero-title my-5">Under Working</h1>
                </div>
            </div>
        </div>
    </section>
</main>
<app-footer></app-footer>